import FileSaver from 'file-saver';
import { isNullOrUndefined } from './object-utils';

export const downloadFile = (response) => {
  const fileName = response.headers['content-disposition']
    .split(';')
    .find((n) => n.includes('filename='))
    .replace('filename=', '')
    .trim();
  const contentType = response.headers['content-type'];
  let blob = new Blob([response.data], { type: contentType });
  FileSaver.saveAs(blob, fileName);
};

export const getStatementIdUtil = (selectedStatement) => {
  let id = null;
  
  if (typeof selectedStatement === 'number' || typeof selectedStatement === 'string') {
    id = parseInt(selectedStatement);
  } else if (selectedStatement) {
    id =
      selectedStatement.statement && parseInt(selectedStatement.statement.id);
  }

  const locationPath = window.location.pathname.split('/');
  if (isNullOrUndefined(id) && locationPath.includes('statement')) {
    id = locationPath[locationPath.indexOf('statement') + 1];
  }
  return id;
};
